module.exports = __webpack_public_path__ + "media/images/athletes/1491-7996a48b3185b16bf7eda2503b638051.png";